import createGetEnumerationsSelector from './createGetEnumerationsSelector';
import { getOutputProperties } from '../getOutputProperties';

export const getOutputEnumerations = createGetEnumerationsSelector(getOutputProperties);